"use client";

import React from "react";
import ModalTabbedExample from "@/examples/modals/ModalTabbedExample";

export default function ModalTabbedPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalTabbedExample />
    </div>
  );
}
